import { CurrencyFormat } from "./CurrencyFormat";

/**
 * Calcular o valor total de cada linha na tabela.
 * @param value - Valor do produto.
 * @param qtd - Quantidade do produto.
 * @param discount - Porcentagem de desconto aplicada.
 * @returns - Valor total com desconto formatado.
 */
export const CalcAmountAndValue = (
  value: number,
  qtd: number,
  discount: number
) => {
  const total = qtd * value;
  const discountAmount = (total * discount) / 100;
  const totalWithDiscount = total - discountAmount;
  return CurrencyFormat(totalWithDiscount);
}

/**
* Calcula o total dos produtos selecionados, considerando o desconto.
* @param selectedProducts - Array de produtos selecionados.
* @param getDiscount - Função para obter o desconto de um produto pelo índice.
* @returns - Valor total com descontos formatado.
*/
export const CalculateTotal = (
  selectedProducts: any,
  getDiscount: (index: number) => number
) => {
  const total = selectedProducts.reduce((acc: any, product: any, index: number) => {
    const totalProduct = product.amount * Number(product.price);
    const discount = (totalProduct * getDiscount(index)) / 100;
    const totalWithDiscount = totalProduct - discount;
    return acc + totalWithDiscount;
  }, 0);

  return CurrencyFormat(total);
}